<template>
  <div class="main moreList">
    <div class="nav">
      <div class="left">
        <div @click="$router.go(-1)" class="icon_back"></div>
      </div>
      {{ titleName }}
    </div>
    <div class="content">
      <van-list v-model="loading" :finished="finished" @load="faechPage">
        <van-cell
          v-for="(item, index) in VideoList"
          :key="index"
          class="list_item"
        >
          <div
            class="hotDLista"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="img_info">
              <viewer style="height: 100%">
                <img :src="item.img" />
              </viewer>
              <div v-if="novelSection == item.nid" class="img_mask">
                <div class="demo"></div>
              </div>
            </div>
            <div class="list_con">
              <router-link
                :to="{
                  path: '/fictionList',
                  query: {
                    sid: sid,
                    nid: item.nid,
                    platform: $route.query.platform,
                    ver: $route.query.ver,
                  },
                }"
              >
                <p>
                  <span class="condition">
                    <span v-if="item.update_status == 1" class="color_active"
                      >更</span
                    >
                    <span v-if="item.update_status == 2">完</span>
                    <i></i></span
                  >{{ item.name }}
                </p>
                <p>
                  {{ item.introduction }}
                </p>
              </router-link>
              <router-link
                :to="{
                  path: '/hosDetails',
                  query: { aid: item.anchor_id, ver: $route.query.ver },
                }"
              >
                <div class="exhibition">
                  <span
                    ><i
                      ><img
                        src="../assets/images/home_ic_label.png"
                        alt="" /></i
                    ><span class="girlName">{{ item.anchor_name }}</span></span
                  >

                  <span v-if="item.update_status == 1" class="color_active"
                    >更新至 {{ item.numbers }} 期</span
                  >
                  <span v-if="item.update_status == 2"
                    >共 {{ item.numbers }} 期</span
                  >
                </div>
              </router-link>
            </div>
          </div>
        </van-cell>
      </van-list>
      <div
        v-if="!loading && finished"
        class="No_more"
        style="text-align: center"
      >
        我也是有底线的
      </div>
    </div>
    <!-- <foot></foot> -->
  </div>
</template>

<script>
/**
 * 更多列表
 * 传了 last_update 1 调用 fetchColumnMore2
 * 未传 last_update 0 调用 fetchColumnMore
 */
// import foot from "../components/Module/footer";
import { mapState, mapMutations, mapActions } from "vuex";
import "../css/List.scss";
export default {
  // components: { foot },
  name: "moreList",
  data() {
    return {
      VideoList: [],
      sid: 0,
      titleName: "",
      listParams: {
        page: 0,
        pageSize: 10,
        sid: 0,
        last_update: 0,
      },
      loading: false,
      finished: false,
    };
  },

  // watch: {
  //   $route(to, from) {
  //     if (to) {
  //       this.finished = true;
  //       this.listParams.page = 1;
  //       this.listParams.pageSize = 10;
  //       // 默认清空
  //       this.VideoList = [];
  //       this.getAllList();
  //     }
  //   },
  // },
  computed: {
    ...mapState("userIndex", ["musicId", "novelSection"]),
  },
  created() {
    // console.log(this.novelSection);
    this.titleName = this.$route.query.name;
    let query = this.$route.query;
    this.sid = this.$route.query.sid;
    this.finished = true;
    this.listParams.page = 1;
    this.listParams.pageSize = 10;
    // 默认清空
    this.VideoList = [];
    this.getAllList();
    // this.fetchColumnMore(query).then(res=>{
    //     this.MoreList = res.data
    //     console.log(this.MoreList)
    // })
  },
  methods: {
    ...mapActions("userIndex", ["fetchColumnMore", "fetchColumnMore2"]),
    ...mapMutations("userIndex", ["setMusicId", "setNovelSection"]),
    async getAllList() {
      let res;
      this.loading = true;
      this.listParams.sid = this.$route.query.sid;
      if (this.$route.query.last_update == 1) {
        this.listParams.last_update = this.$route.query.last_update;
        res = await this.fetchColumnMore2(this.listParams)
      } else {
        res = await this.fetchColumnMore(this.listParams)
      }

      this.loading = false;
      if (!res || res.data == "") {
        this.finished = true;
        return false;
      }
      this.finished = false;
      this.VideoList = res.data;
    },
    async faechPage() {
      let res;
      this.listParams.page++;
      this.loading = true;
      this.listParams.sid = this.$route.query.sid;
      if (this.$route.query.last_update == 1) {
        this.listParams.last_update = this.$route.query.last_update;
        res = await this.fetchColumnMore2(this.listParams)
      } else {
        res = await this.fetchColumnMore(this.listParams)
      }

      this.loading = false;
      if (!res || res.data == "") {
        this.finished = true;
        return false;
      }
      this.VideoList = this.VideoList.concat(res.data);
    },
  },
};
</script>
